import React from 'react'
import { version } from 'release-notes-list'

const ApplicationVersion = (props) => {
  const x = version.replace('{Build.BuildNumber}', 'DEV')
  return <React.Fragment>v. {x}</React.Fragment>
}

export {
  ApplicationVersion
}